/**
 * 调研模块
 */
import { PAGE_LEVEL } from '@/constants';
import { isElectron } from '@/utils/electron';
export default {
  path: '/research',
  redirect: '/activity/survey',
  meta: {
    pageLevel: PAGE_LEVEL.FIRST,
    name: 'routers.survey_survey',
    localeModules: ['research', 'strategy', 'roadshow', 'schedule', 'summary']
  },
  children: [
    {
      path: 'activity/:id',
      name: 'researchActivity',
      component: () => import(/* webpackChunkName: 'research-activity' */ '@/pages/research/activity/activityView.vue'),
      meta: {
        componentName: 'ResearchActivityDetailIndex',
        pageLevel: PAGE_LEVEL.SECOND,
        parent: '/activity/survey',
        otherParent: ['/find/self-selected', '/activity/roadshow'],
        name: 'routers.survey_survey_detail',
        keepAlive: false,
        electronSingle: true,
        hideBreadcrumb: isElectron,
        hideBreadcrumbInWorkBuddy: true,
        allowMenuBack: true,
        dynamicTitle: true
      }
    },
    // 策略会
    {
      path: 'strategy/:id',
      name: 'researchStrategy',
      component: () => import(/* webpackChunkName: 'research-strategy' */ '@/pages/research/strategy/strategyView.vue'),
      meta: {
        componentName: 'ResearchDetailIndex',
        name: 'routers.survey_strategy_detail',
        pageLevel: PAGE_LEVEL.SECOND,
        parent: '/activity/strategy',
        otherParent: ['/activity/roadshow'],
        keepAlive: false,
        electronSingle: true,
        hideBreadcrumb: isElectron
      }
    }
  ]
};
